import { Account } from '@mkp/account/models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const accountApiActions = createActionGroup({
  source: 'Account/API',
  events: {
    'Load Account Success': props<{ account: Account }>(),
    'Load Account Failure': props<{ error: { message: string } }>(),
    'Load Accounts Success': props<{ accounts: Account[] }>(),
    'Load Accounts Failure': props<{ error: { message: string } }>(),
    'Load Account By Legal Entity External Id Success': props<{
      account: Account;
      selectedAccountId: Account['id'];
    }>(),
    'Load Account By Legal Entity External Id Failure': props<{ error: { message: string } }>(),
    'Add Account': props<Pick<Account, 'legalEntityId' | 'name'>>(),
    'Add Account Success': props<{ account: Account }>(),
    'Add Account Failure': props<{ error: { message: string } }>(),
    'Archive Account': props<Pick<Account, 'id' | '_version'>>(),
    'Archive Account Success': props<{ account: Account }>(),
    'Archive Account Failure': props<{ error: { message: string } }>(),
    'Load User Accounts': emptyProps(),
    'Load User Accounts Success': props<{ accounts: Account[] }>(),
    'Load User Accounts Failure': props<{ error: { message: string } }>(),
    'Refresh Selected Account Success': props<{ account: Account }>(),
    'Refresh Selected Account Failure': props<{
      error: { message: string };
    }>(),
    'Refresh Selected Account Not Found': props<{
      accountId: string;
    }>(),
    'Refresh All Accounts Success': props<{ accounts: Account[] }>(),
    'Refresh All Accounts Failure': props<{ error: { message: string } }>(),
  },
});
